import React, { Component } from "react";
import { connect } from "react-redux";
import { Label } from "react-bootstrap";
import { LoaderButton } from "ctia-ui";
import InfoBar from "containers/Devices/DeviceInfoBar";
import ModelVersions from "containers/Devices/ModelVersions";
// import { clearDeviceList } from "actions/devices";
import { fetchModelCertifiedVersions, clearModel } from "actions/model";

class CertifiedDevice extends Component {
  fetchDevices = () => {
    const { fetchModelCertifiedVersions, match, devices } = this.props;

    if (devices === null || devices.list === null) {
      return setTimeout(() => this.props.history.push("/devices"), 100);
    }

    fetchModelCertifiedVersions(match.params.id);
  };

  componentDidMount() {
    this.fetchDevices();
  }

  componentWillReceiveProps(nextProps) {
    const newId = nextProps.match.params.id;
    const { match, fetchModelCertifiedVersions } = this.props;

    if (newId !== match.params.id) {
      fetchModelCertifiedVersions(newId);
    }
  }

  componentWillUnmount() {
    // this.props.clearDeviceList();
    this.props.clearModel();
  }

  backToList = () => {
    this.props.clearModel();
    this.props.history.push("/devices");
  };

  render() {
    const { model, user, devices, match } = this.props;

    if (!model || !devices) return null;
    if (model && !model.versions) return null;

    const showLink = !user.isLab;
    const modelId = match.params.id;
    const modelInfo = devices.list[modelId];

    return (
      <div>
        <h1>
          Certified Device <Label>{modelInfo.modelnumber}</Label>
        </h1>
        <div style={{ paddingTop: 25 }}>
          <LoaderButton
            text="&larr; Return to List"
            style={{ marginBottom: 15 }}
            onClick={this.backToList}
          />
          <InfoBar modelId={modelId} />
          <ModelVersions tableData={model.versions} showLink={showLink} />
        </div>
      </div>
    );
  }
}

function mapStateToProps({ model, user, devices }) {
  return { model, user, devices };
}

export default connect(mapStateToProps, {
  // clearDeviceList,
  fetchModelCertifiedVersions,
  clearModel
})(CertifiedDevice);



// WEBPACK FOOTER //
// ./src/containers/Devices/CertifiedDevice.js